export default __webpack_public_path__ + "static/media/keenpoint-logo-circle-nobg.2b2c9e97.png";